module.exports = __webpack_public_path__ + "static/media/home-depot.837232fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/where-to-buy/home-depot.jpg
// module id = 1315
// module chunks = 0